import {Action} from '@ngrx/store';
import {AusmitError} from "../../shared/interfaces";
import {CriteriaModel} from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
	GetStoreById = 'GetStoreById',
	GetStoreByIdSuccess = 'GetStoreByIdSuccess',
	GetStoreByIdError = 'GetStoreByIdError',

	GetStores = 'GetStores',
	GetStoresSuccess = 'GetStoresSuccess',
	GetStoresError = 'GetStoresError',
}

export class GetStoreById implements Action {
	readonly type = ActionTypes.GetStoreById;

	constructor(public payload: { storeId: string }) {
	}
}

export class GetStoreByIdSuccess implements Action {
	readonly type = ActionTypes.GetStoreByIdSuccess;

	constructor(public payload: any) {
	}
}

export class GetStoreByIdError implements Action {
	readonly type = ActionTypes.GetStoreByIdError;

	constructor(public payload: AusmitError) {
	}
}

export class GetStores implements Action {
	readonly type = ActionTypes.GetStores;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetStoresSuccess implements Action {
	readonly type = ActionTypes.GetStoresSuccess;

	constructor(public payload: any) {
	}
}

export class GetStoresError implements Action {
	readonly type = ActionTypes.GetStoresError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| GetStoreById
	| GetStoreByIdSuccess
	| GetStoreByIdError
	| GetStores
	| GetStoresSuccess
	| GetStoresError;
